import { MutableRefObject, useRef } from 'react';
import FormWithProvider from 'components/forms/form/Form';
import { AsyncTypeAheadFieldInstance } from 'components/forms/typeAheadField/AsyncTypeAheadField.types';
import { GetIntegrationAgencySettingsResponseTO } from 'models/InternalIntegrationSetting';
import { PROPERTY_STATUS } from 'models/Properties';
import HeaderWithFilters from './headerWithFilters/HeaderWithFilters';
import PropertiesResults from './propertiesResults/PropertiesResults';

const defaultValues = {
  status: PROPERTY_STATUS.ACTIVE,
  tags: [],
};

const PropertiesList = ({
  integrationAgencySettings,
}: {
  integrationAgencySettings: GetIntegrationAgencySettingsResponseTO;
}) => {
  const propertySearchFieldRef = useRef<AsyncTypeAheadFieldInstance>();

  const handleClearPropertiesSearch = () => {
    propertySearchFieldRef.current?.clear();
  };

  return (
    <section data-testid="properties-list">
      <FormWithProvider
        defaultValues={defaultValues}
        // filter changes are handled by the useWatch hook in the PropertiesResults component
        onSubmit={() => {}}
      >
        <HeaderWithFilters
          integrationAgencySettings={integrationAgencySettings}
          onFilterClear={handleClearPropertiesSearch}
          propertySearchFieldRef={
            propertySearchFieldRef as MutableRefObject<AsyncTypeAheadFieldInstance>
          }
        />
        <PropertiesResults
          integrationAgencySettings={integrationAgencySettings}
        />
      </FormWithProvider>
    </section>
  );
};

export default PropertiesList;
